import sendRequest from "@/libs/sendRequest";

export const clients = {
    namespaced: true,
    state: {
        route_clients: null,
        clients: [],
        total_clients: 0,
    },
    getters: {
        getRouteClients: (state) => state.route_clients || [],
        getClients: (state) => state.clients,
        getTotalClients: (state) => state.total_clients,
    },
    mutations: {
        setRouteClients: (state, payload) => state.route_clients = payload,
        setClients: (state, payload) => {
            state.clients = payload;
        },
        setTotalClients: (state, payload) => {
            state.total_clients = payload;
        },
    },
    actions: {
        obtainRouteClients: async ({ commit, rootGetters }, query) => {
            query.datatable = false
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest(`administrator/heishop/clientes/route_clients`, 'GET', null, null, query, custom_headers)

            if(response.success && response.data) {
                commit('setRouteClients', response.data.clientes)
            }
            else if(!response.success && response.errors) {
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
            else {
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
        },
        list: async ({ commit, rootGetters }, { page = 1, rows = 10, search = '', order_by = 'Id', order_asc = true }) => {
            const custom_headers = rootGetters.getHeaders

            try {
                const response = await sendRequest(`administrator/heishop/clientes/list?isDatatable=true&page=${page}&rows=${rows}&search=${search}&order_by=${order_by}&order_asc=${order_asc}`, 'GET', null, null, null, custom_headers);
                
                if(response.data) {
                    commit('setClients', response.data.list.result); 
                    commit('setTotalClients', response.data.list.total_rows);
                } else {
                    console.error('Error al cargar los clientes:', response.errors);
                }
            } catch (error) {
                console.error('Error en la solicitud:', error);
            }
        },
        add: async ({ dispatch, rootGetters }, payload) => {
            const custom_headers = rootGetters.getHeaders;
            const response = await sendRequest(`administrator/heishop/clientes/assign_clients`, 'POST', null, payload.body, payload.query, custom_headers);

            if(response.success && response.data) {
                // commit('setRouteClients', response.data.clientes)
                dispatch('showAlert', 'Los clientes han sido añadidos', { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
            else {
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
        }
    },
};